import * as goldenbet888 from './zh.goldenbet888';
import { themeName } from '@/helpers/getThemeConfig';

const exports = {
  goldenbet888,
} as Record<string, any>;

export default exports[themeName];
